/**
 * @todo Удалить строку с экспериментом
 * @description Данный функционал появился в задаче CD-161150, будет удалён в задаче CD-161151
 */
export const FROM_OWNER_TOOLTIP_EXPERIMENT = 'from_owner_tooltip_experiment';
